import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  close1s6qtnweux4fu as close,
  ObjectPool3iks1t8z0qq3m as ObjectPool,
} from './Pool.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultPoolClass;
function DefaultPool() {
  if (DefaultPoolClass === VOID) {
    class $ {
      constructor(capacity) {
        this.q4m_1 = capacity;
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.q4m_1;
        tmp.r4m_1 = Array(size);
        this.s4m_1 = 0;
      }
      t4m(instance) {
      }
      u4m(instance) {
        return instance;
      }
      v4m(instance) {
      }
      w4m() {
        if (this.s4m_1 === 0)
          return this.p4m();
        this.s4m_1 = this.s4m_1 - 1 | 0;
        var idx = this.s4m_1;
        var tmp = this.r4m_1[idx];
        var instance = !(tmp == null) ? tmp : THROW_CCE();
        this.r4m_1[idx] = null;
        return this.u4m(instance);
      }
      x4m(instance) {
        this.v4m(instance);
        if (this.s4m_1 === this.q4m_1) {
          this.t4m(instance);
        } else {
          var _unary__edvuaz = this.s4m_1;
          this.s4m_1 = _unary__edvuaz + 1 | 0;
          this.r4m_1[_unary__edvuaz] = instance;
        }
      }
      uz() {
        var inductionVariable = 0;
        var last = this.s4m_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = this.r4m_1[i];
            var instance = !(tmp == null) ? tmp : THROW_CCE();
            this.r4m_1[i] = null;
            this.t4m(instance);
          }
           while (inductionVariable < last);
        this.s4m_1 = 0;
      }
    }
    protoOf($).l6 = close;
    initMetadataForClass($, 'DefaultPool', VOID, VOID, [ObjectPool()]);
    DefaultPoolClass = $;
  }
  return DefaultPoolClass;
}
//region block: exports
export {
  DefaultPool as DefaultPool2gb1fm4epwgu9,
};
//endregion

//# sourceMappingURL=DefaultPool.mjs.map
